<template>
  <div class="main-content queryCharge">
    <search-item
      :key="identify"
      :ref="identify"
      :is-append-query="isAppendQuery"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataBykeyWord"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
      @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="chargeGrid.gridParams"
        :grid-options="chargeGrid.gridOptions"
        :column-defs="chargeGridColumnDefs"
        :row-data="chargeGrid.rowData"
        :show-row-groups="dataListDragGroup"
      />
    </div>
    <div id="footer-wrapper-tab-charge" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyChargeGrid.labelText" />
        <span v-if="['Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyChargeGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc && ['Writeoff'].includes(viewSource)"
          :key="1"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
          :data-field="totalDataField"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :source="viewSource"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['Writeoff'].includes(viewSource)" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['Writeoff'].includes(viewSource)"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
          data-field="unverifiedAmount"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :source="viewSource"
          :show-wht="showWht"
        />
        <charge-count-group
          v-if="reCalc && ['MakeInvoice'].includes(viewSource)"
          :key="3"
          :selected-count="totalAmountToCurrencyChargeGrid.selectedCount"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyChargeGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
      </div>
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.totalChargeGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationCharge"
        :config-module="gridConfigModule"
        :total="searchConditions.totalChargeGrid"
        :page.sync="searchConditions.pageNumChargeGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getGridSelected, getGridSelectedIds, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { Once, stringToBool } from '@/utils/commonUtil'
import { queryChargeList } from '@/api/clearing/invoice'
import lodash from 'lodash'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'

export default {
  name: 'QueryCharge',
  components: { CargoAgGridWrapper, searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, required: true, default: 'queryCharge' }, // ID
    viewSource: { type: String, required: true, default: 'MakeInvoice' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    confirmState: { type: Number, default: -1 }, // 确认状态
    hasDiffCharge: { type: Number, default: -1 }, // 是否关联差异对冲费用
    hasBilling: { type: Number, default: -1 }, // 是否关联账单
    hasBillPayment: { type: Number, default: -1 }, // 是否关联付款申请
    paidOff: { type: Number, default: 0 }, // 是否销账
    commission: { type: Number, default: 0 }, // 是否佣金
    advance: { type: Number, default: -1 }, // 是否垫付
    isNeedInvoice: { type: Number, default: -1 }, // 是否开票
    shared: { type: Number, default: 0 }, // 是否分摊费用
    adjustment: { type: Number, default: -1 }, // 是否调整
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    showInvoiceNo: { type: Boolean, default: false }, // 显示发票号
    showBillingNo: { type: Boolean, default: false }, // 显示账单号
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    showIncoTerm: { type: Boolean, default: false }, // 显示贸易条款
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲开票结算单位
    jobStateParam: { type: String, default: 'InvoiceJobState' }, // InvoiceJobState, 开票-未开票-业务状态查询(发票)
    chargeStateParam: { type: String, default: 'InvoiceChargeState' }, // InvoiceChargeState, 开票-费用-费用状态查询(发票)
    confirmStateParam: { type: String, default: 'InvoiceChargeConfirmState' }, // InvoiceChargeConfirmState, 开票-费用-费用确认状态查询(发票)
    currentBillingBranchId: { type: Number, default: 0 }, // 当前账单所属分公司(业务详情-账单页签)
    departmentTeamUser: { type: Array, default: () => [] }, // 同部门的人：佣金(淳宏)判断费用创建人同组
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    arField: { type: String, default: 'isReceivable' }, // 收付字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '5021' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190601' }, // 列表设置
    writeoffHasInvoice: { type: Number, default: -1 }, // 销账-是否已开票(销账)
    invoiceHasBillPayment: { type: Number, default: -1 }, // 是否已申请付款(销账)
    internalCharge: { type: Boolean, default: false }, // 内结
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      defaultSearchItems: [],
      searchItemAutoInit: true,
      searchItemCode: '按费用查询',
      // configModule: '5021',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'),
      perConfigName: '',
      gridRefreshId: 0,
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected,
          onRowClicked: this.onRowClicked
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: true,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.branchId)
                  },
                  printMethod: this.toSearchTemplate
                }
              }
            }, width: 150 },
          { headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
            }, width: 180 },
          { headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'isOversea', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.overseaLabelFunc(stringToBool(params.value))
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_separateNumber'), field: 'jobHbl', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_invoiceHeader'), field: 'invoiceTitle', width: 200, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', hide: !this.showInvoiceNo, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_billNo'), field: 'billingNo', hide: !this.showBillingNo, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_accountStatementNo'), field: 'billingGroupNo', width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_customer'), field: 'jobCustomerId', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
            }, width: 180 },
          { headerName: this.$t('Invoice.invoice_businessType'), field: 'jobLob', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'jobVesselFlight', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            filter: false,
            filterParams: {},
            width: 120
          }, {
            headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', initialWidth: 120, enableRowGroup: true,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.000')
            }
          }, { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            filter: false,
            filterParams: {},
            width: 120
          },
          {
            headerName: this.$t('Partners.isFba'),
            colId: 'fba',
            field: 'fba',
            width: 180,
            enableRowGroup: true,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 180,
            enableRowGroup: true,
            hide: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DueDate'),
            field: 'dueDate',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FbaJob.DestinationDistribution'),
            colId: 'destinationDistribution',
            field: 'destinationDistribution',
            width: 180,
            enableRowGroup: true,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
            }
          },
          {
            headerName: this.$t('FbaJob.ExpressNo'),
            colId: 'expressNo',
            field: 'expressNo',
            width: 180,
            enableRowGroup: true,
            hide: true
          },
          {
            headerName: this.$t('FbaJob.RemoteWarehouse'),
            colId: 'remoteWarehouse',
            field: 'remoteWarehouse',
            width: 180,
            enableRowGroup: true,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: 'Shipment Id',
            colId: 'shipmentId',
            field: 'shipmentId',
            width: 180,
            enableRowGroup: true,
            hide: true
          },
          {
            headerName: 'Reference Id',
            colId: 'referenceId',
            field: 'referenceId',
            width: 180,
            enableRowGroup: true,
            hide: true
          },
          { headerName: this.$t('Invoice.invoice_sales'), field: 'jobSales', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }, width: 100 },
          { headerName: this.$t('Invoice.invoice_cargoSalesId'), field: 'cargoSalesId', hide: true, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }, width: 100 },
          { headerName: this.$t('Invoice.invoice_accrued'), field: 'jobIsProvisioned', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }, width: 100 },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', initialWidth: 100, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.FieldOperation'), field: 'jobSiteOp', colId: 'jobSiteOp', initialWidth: 100, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          { headerName: this.$t('Invoice.invoice_operation'), field: 'jobOp', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }, width: 100 },
          { headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_paymentType'), field: 'isReceivable', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_feeStatus'), field: 'chargeState', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.chargeStateLabFun(Number(params.value))
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_confirmStatus'), field: 'confirmState', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.chargeConfirmStateLabFun(Number(params.value))
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
            }, width: 130 },
          { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_customJobType'), field: 'jobCustomJobType', enableRowGroup: true,
            valueGetter: (params) => {
              return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
            },
            width: 140 },
          { headerName: this.$t('Invoice.invoice_quantity'), field: 'quantity', width: 100, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount', enableRowGroup: true,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount', enableRowGroup: true,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120,
            summaryMode: 'sum' },
          { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount', enableRowGroup: true,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_itemNo'), field: 'jobPono', hide: true, width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_contactPerson'), field: 'contactPerson', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'verifiedAmount', hide: !this.showVerifiedAmount,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_amountNotWrittenOff'), field: 'unverifiedAmount', hide: !this.showUnverifiedAmount,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_invoicingMethod'), field: 'cdInvoiceMode', hide: true, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.invoiceModeLableFun(Number(params.value))
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_paymentApplicationNo'), field: 'billPaymentNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_bookingNo'), field: 'jobBookingNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_containerNo'), field: 'containerContainerNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_businessReferenceNumber'), field: 'jobCustomerRefNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField1'), field: 'jobUserDefinedField1', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField2'), field: 'jobUserDefinedField2', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField3'), field: 'jobUserDefinedField3', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField4'), field: 'jobUserDefinedField4', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', hide: true, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_chargesRemarks'), field: 'remarks', width: 160, enableRowGroup: true },
          {
            headerName: this.$t('Invoice.invoice_settleDepartmentPrefix'),
            field: 'settleDepartmentPrefix',
            hide: true,
            enableRowGroup: true,
            width: 140,
            cellRenderer: (params) => {
              return ColumnUtils.settleDepartmentAllrefixLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Invoice.RedChargesOrNot'), field: 'offsetState', hide: true, width: 120, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.offsetStateLabFun(Number(params.value))
            }
          },
          { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', hide: true, width: 120, enableRowGroup: true,
            cellRenderer: (params) => {
              const state = InvoiceConstant.getCommonState(Number(params.value), InvoiceConstant.INVOICE_TYPES)
              return state === null ? '' : this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'changer',
            field: 'changer',
            initialWidth: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.ConsignationRelationNumber'), enableRowGroup: true,
            colId: 'trustFromJob', field: 'trustFromJob', hide: true, width: 120
          }, {
            headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), enableRowGroup: true,
            colId: 'relatedJob', field: 'relatedJob', hide: true, width: 120
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
            field: 'userDefinedRoleId1',
            colId: 'userDefinedRoleId1',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
            field: 'userDefinedRoleId2',
            colId: 'userDefinedRoleId2',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChargeCreadBy'),
            colId: 'chargeCreatedBy',
            field: 'chargeCreatedBy',
            initialWidth: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          }, { headerName: 'ETD',
            colId: 'jobEtd',
            field: 'jobEtd',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, { headerName: 'ETA',
            colId: 'jobEta',
            field: 'jobEta',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: 'ATD',
            colId: 'jobAtd',
            field: 'jobAtd',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          }, {
            headerName: 'ATA',
            colId: 'jobAta',
            field: 'jobAta',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('Billing.DueDate'),
            colId: 'chargeDueDate',
            field: 'chargeDueDate',
            width: 120,
            hide: true,
            enableRowGroup: true,
            valueFormatter: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
            field: 'khPlateNumber',
            colId: 'khPlateNumber',
            width: 120,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
            field: 'khTrailerNumber',
            colId: 'khTrailerNumber',
            width: 120,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ExpenseBoxNo'),
            field: 'relationContainerNo',
            initialWidth: 200,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('SeaExport.ProjectName'),
            field: 'jobProjectName',
            colId: 'jobProjectName',
            hide: true,
            enableRowGroup: true,
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
            colId: 'cooperatebranch',
            field: 'cooperatebranch',
            width: 160, minWidth: 160,
            enableRowGroup: true,
            hide: !this.useOrderCenterMode
          }, {
            headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
            colId: 'cooperateBusinessType',
            field: 'cooperateBusinessType',
            width: 200, minWidth: 200,
            enableRowGroup: true,
            hide: !this.useOrderCenterMode
          }, {
            headerName: this.$t('Billing.billingJob_carrier'), field: 'jobCarrierId', enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
            }, width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
            field: 'jobDispatchingPlace',
            colId: 'jobDispatchingPlace',
            enableRowGroup: true,
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
            field: 'actTakeTime',
            colId: 'actTakeTime',
            enableRowGroup: true,
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Payment.SONO'), field: 'soNo', initialWidth: 200, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.soNoLabelFunc2(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.TradeTerms2'),
            field: 'incoTerm',
            colId: 'incoTerm',
            width: 180,
            enableRowGroup: true,
            hide: !this.showIncoTerm
          },
          {
            headerName: this.$t('SeaExport.CustomerService'),
            field: 'jobCsr',
            colId: 'jobCsr',
            hide: true,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr')
            },
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
            field: 'salesOffice',
            colId: 'salesOffice',
            hide: true,
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
            field: 'opOffice',
            colId: 'opOffice',
            hide: true,
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('SeaExport.OperationDate'), field: 'jobCustomsDate', hide: true, initialWidth: 120, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('Payment.businessStatus'), field: 'jobState', initialWidth: 120,
            valueFormatter: (params) => {
              return ColumnUtils.jobStateLabelFunc(params.value)
            }
          }
        ],
        rowData: []
      },
      searchConditions: {
        totalChargeGrid: 0, // 按费用
        pageNumChargeGrid: 1, // 按费用
        pageSize: 20,
        snapshotConditionsCharge: [], // 高级查询条件（点击查询时的快照状态）
        requiresCharge: [],
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 确认状态
      },
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Invoice.invoice_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      appendQuery: false, // 追加查询
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      queryOfficeId: 0 // 记录查询时的分公司Id
    }
  },
  computed: {
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyChargeGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    },
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    chargeGridColumnDefs() {
      const curChargeGridColumnDefs = this.chargeGrid.columnDefs
      if (this.showWhtTax) {
        const whtColumns = [
          { headerName: this.$t('FinanceManage.charge_whtTaxRate'),
            field: 'whtTaxRate',
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            },
            width: 100 },
          { headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'whtTaxLocalAmount',
            hide: !this.showWhtTax,
            enableRowGroup: true,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            },
            width: 100,
            summaryMode: 'sum' },
          { headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'notWhtAmount',
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              const notWhtAmount = ColumnUtils.notWhtAmountLabel(params.data)
              return this.$numeral(notWhtAmount).format('0.00')
            },
            width: 100,
            summaryMode: 'sum' }
        ]
        curChargeGridColumnDefs.push(...whtColumns)
      }
      return curChargeGridColumnDefs
    }
  },
  watch: {
    async isShow(newVal) {
      if (newVal) {
        // 刷新时默认页签没变，不会重新加载。恢复到created
        // await cache.load(cacheName.CONFIG)
        // // 配置参数
        // this.initConfig()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
    this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
    // const context = this
    // this.documentManage.set('toSearchTemplate', function(value) {
    //   context.toSearchTemplate(value)
    // })
  },
  mounted() {

  },
  methods: {
    // 配置参数
    async initConfig() {
      this.searchConditions.invoiceReceiveChargeState = String(cache.config.get('InvoiceReceiveChargeState'))
      this.searchConditions.invoicePayChargeState = String(cache.config.get('InvoicePayChargeState'))
      this.searchConditions.jobStateParam = String(cache.config.get(this.jobStateParam))
      this.searchConditions.chargeStateParam = String(cache.config.get(this.chargeStateParam))
      this.searchConditions.confirmStateParam = String(cache.config.get(this.confirmStateParam))
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      //
      const jobStates = []
      this.searchConditions.jobStateParam.split(',').forEach(function(value) {
        jobStates.push(Number(value))
      })
      this.searchConditions.jobStates = jobStates
      //
      const chargeStates = []
      if (this.chargeStateParam !== 'InvoiceChargeState') {
        this.searchConditions.chargeStateParam.split(',').forEach(function(value) {
          chargeStates.push(Number(value))
        })
      }
      this.searchConditions.chargeStates = chargeStates
      //
      const confirmStates = []
      this.searchConditions.confirmStateParam.split(',').forEach(function(value) {
        confirmStates.push(Number(value))
      })
      this.searchConditions.confirmStates = confirmStates
    },
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNumChargeGrid = 1
      const finallyConditions = []
      // 高级查询条件组装
      // if (!simpleTriggerMode) {
      const advConditions = lodash.cloneDeep(conditions)
      // 获取追加查询条件
      this.appendQuery = JobUtils.appendQueryCondition(advConditions)
      if (this.isAr !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', this.isAr, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.commission !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.COMMISSION', this.commission, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.advance !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.isNeedInvoice !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', this.isNeedInvoice, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.shared !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.SHARED', this.shared, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.oversea > -1) {
        const option = new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.paidOff > -1) {
        const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.paidOff, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', conditions)) {
        const option = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', '', (this.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.hasBilling !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.BILLING_UUID', '', (this.hasBilling === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
        finallyConditions.push(option.formatObj2Json())
      }
      if (['Writeoff'].includes(this.viewSource)) {
        const option = new AdvancedSearchOption(null, 'isWriteOffAll', 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 费用是否红冲， 默认查询未红冲的费用
      if (AdvancedSearchOption.hasField('charge.OFFSET_STATE', advConditions)) {
        const offsetState = AdvancedSearchOption.removeOption('charge.OFFSET_STATE', advConditions)
        if (offsetState != null) {
          if (offsetState.value) {
            const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', [1, 2], OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          } else {
            const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
        }
      } else {
        const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', [0, 1, 2], OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.hasDiffCharge !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.DIFF_CHARGE_UUID', '', (this.hasDiffCharge === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
        finallyConditions.push(option.formatObj2Json())
      }
      // 业务日期
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'job.BUSINESS_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否查询受控费用
      if (this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 默认
      if (this.searchConditions.jobStates.length > 0) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 费用状态
      if (this.searchConditions.chargeStates.length > 0) {
        if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
          const option = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', this.searchConditions.chargeStates, OperatorConstants.OPERATOR_IN.code)
          finallyConditions.push(option.formatObj2Json())
        } else {
          const option = AdvancedSearchOption.getOption('charge.CHARGE_STATE', advConditions)
          const valueArray = option.value
          const chargeStateCondition = [-1]
          const chargeStates = this.searchConditions.chargeStates
          valueArray.forEach(function(value) {
            if (chargeStates.indexOf(value) !== -1) { // 当前范围内
              chargeStateCondition.push(value)
            }
          })
          AdvancedSearchOption.removeOption('charge.CHARGE_STATE', advConditions)
          //
          const option1 = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStateCondition, OperatorConstants.OPERATOR_IN.code)
          finallyConditions.push(option1.formatObj2Json())
        }
      }
      if (this.searchConditions.confirmStates.length > 0) {
        const option = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', this.searchConditions.confirmStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // CARGO-673巴士悦信：参数【InvoiceChargeState开票-费用-费用状态查询(发票)】分为应收、应付2种
      const chargeStateParam = new AdvancedSearchOption(null, 'chargeStateParam', this.chargeStateParam, OperatorConstants.OPERATOR_EQUAL.code)
      finallyConditions.push(chargeStateParam.formatObj2Json())
      const invoiceReceiveChargeState = new AdvancedSearchOption(null, 'invoiceReceiveChargeState', this.searchConditions.invoiceReceiveChargeState, OperatorConstants.OPERATOR_EQUAL.code)
      finallyConditions.push(invoiceReceiveChargeState.formatObj2Json())
      const invoicePayChargeState = new AdvancedSearchOption(null, 'invoicePayChargeState', this.searchConditions.invoicePayChargeState, OperatorConstants.OPERATOR_EQUAL.code)
      finallyConditions.push(invoicePayChargeState.formatObj2Json())
      //
      finallyConditions.push(...advConditions)
      // } else {
      //   finallyConditions.push(...conditions)
      // }
      // 对冲开票/销账
      if (this.exceptKeys.length > 0) {
        const option = new AdvancedSearchOption(null, 'charge.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.exceptAdvancedSearchOption) {
        finallyConditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
      }
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('charge.ACCOUNT_ID', conditions)) {
        const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_ID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }

      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditionsCharge = finallyConditions
      this.toQueryChargeList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        this.searchConditions.pageNumChargeGrid = 1
        const conditions = []
        const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        if (conditions.length > 0) {
          this.appendQuery = false
          this.fetchData(conditions, true)
        }
      }
    },
    // 分页触发查询
    fetchDataByPage(param) {
      console.log('fetchDataByPage', param)
      this.toQueryChargeList()
    },
    toQueryChargeList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditionsCharge: conditions, requiresCharge: requires, pageNumChargeGrid: pageNum, pageSize } = this.searchConditions
      if (this.showFba) { requires.push('fba') }
      if (this.showIncoTerm) { requires.push('incoTerm') }
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, currentBillingBranchId: this.currentBillingBranchId, 'requestSource': 'WriteOff' }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.chargeGrid.gridOptions.api, 'uuid')
      queryChargeList(requestBody).then(res => {
        console.log('queryChargeList', res.data.list)
        let results = res.data.list
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.chargeGrid.rowData, results, this.appendQuery)
        }
        this.chargeGrid.rowData = results
        this.searchConditions.totalChargeGrid = this.appendQuery ? results.length : Number(res.data.total)
        //
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
        this.totalAmountToCurrencyChargeGrid.selectionCountLabel = ''
        if (this.isAr === -1) {
          this.totalAmountToCurrencyChargeGrid.labelText = this.$t('Message.All2')
        } else if (this.isAr === 0) {
          this.totalAmountToCurrencyChargeGrid.labelText = this.$t('Clearing.Payable')
        } else if (this.isAr === 1) {
          this.totalAmountToCurrencyChargeGrid.labelText = this.$t('Clearing.Receivable')
        }
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    //
    initCustomSearchItems() {
      if (this.viewSource === 'MakeInvoice') { // 开票
        this.chargeStateConditionCharge()
      }
      // 默认结算单位
      const defaultSearchFields = []
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'Invoice.invoice_settlementCompany'
          searchField.itemName = 'charge.ACCOUNT_ID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 是否已核销
      if (this.viewSource === 'Writeoff') {
        let searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.PAID_OFF'
        searchField.itemLabel = 'Invoice.invoice_wroteOffOrNot'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 销账-是否已开票(销账)
        if ([0, 1].includes(this.writeoffHasInvoice)) {
          const searchField = new AdvancedSearchField()
          searchField.action = 2
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'charge.INVOICE_UUID'
          searchField.itemLabel = 'Invoice.invoice_invoicedOrNot'
          searchField.selected = 1
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          searchField.lock = true
          searchField.defaultValue = this.writeoffHasInvoice === 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 是否已申请付款(销账)
        // if ([0, 1].includes(this.invoiceHasBillPayment)) {
        //   const searchField = new AdvancedSearchField()
        //   searchField.action = 2
        //   searchField.itemType = 'select'
        //   searchField.fieldType = 'FIELD_IS_NOT_NULL'
        //   searchField.itemCondition = []
        //   searchField.defaultConditionVal = ''
        //   searchField.itemName = 'charge.BILL_PAYMENT_UUID'
        //   searchField.itemLabel = 'Invoice.invoice_appliedForPaymentOrNot'
        //   searchField.selected = 1
        //   searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        //   searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        //   searchField.lock = true
        //   searchField.defaultValue = this.invoiceHasBillPayment === 1
        //   defaultSearchFields.push(searchField.formatObj2Json())
        // }
        // 业务状态
        if (this.searchConditions.jobStates.length > 0) {
          const dataProvider = []
          this.searchConditions.jobStates.forEach(function(code) {
            dataProvider.push(CommonState.getStateByCode(SystemConstants.JOB_STATES, code))
          })
          console.log('jobStates: dataProvider ', dataProvider)
          const searchField = new AdvancedSearchField()
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'job.JOB_STATE'
          searchField.itemLabel = 'Invoice.invoice_businessStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dataCacheKey = 'local_cache_SystemConstants$JOB_STATES'
          searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'SystemConstants.JOB_STATES'
          searchField.dataProvider = dataProvider
          if (dataProvider.length === 0) {
            searchField.valueExpression = ''
          }
          searchField.lock = false
          searchField.defaultValue = []
          searchField.action = 2
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 费用状态
        if (this.searchConditions.chargeStates.length > 0) {
          const dataProvider = []
          this.searchConditions.chargeStates.forEach(function(code) {
            dataProvider.push(CommonState.getStateByCode(ChargeConstants.CHARGE_STATES, code))
          })
          console.log('chargeStates: dataProvider ', dataProvider)
          const searchField = new AdvancedSearchField()
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'charge.CHARGE_STATE'
          searchField.itemLabel = 'Invoice.invoice_feeStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_STATES'
          searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'ChargeConstants.CHARGE_STATES'
          searchField.dataProvider = dataProvider
          if (dataProvider.length === 0) {
            searchField.valueExpression = ''
          }
          searchField.lock = false
          searchField.defaultValue = []
          searchField.action = 2
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 确认状态
        if (this.searchConditions.confirmStates.length > 0) {
          const dataProvider = []
          this.searchConditions.confirmStates.forEach(function(code) {
            dataProvider.push(CommonState.getStateByCode(ChargeConstants.CONFIRM_STATES, code))
          })
          console.log('confirmStates: dataProvider ', dataProvider)
          const searchField = new AdvancedSearchField()
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'charge.CONFIRM_STATE'
          searchField.itemLabel = 'Invoice.invoice_confirmStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dataCacheKey = 'local_cache_ChargeConstants$CONFIRM_STATES'
          searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'ChargeConstants.CONFIRM_STATES'
          searchField.dataProvider = dataProvider
          if (dataProvider.length === 0) {
            searchField.valueExpression = ''
          }
          searchField.lock = false
          searchField.defaultValue = []
          searchField.action = 2
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 到期日计算状态
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.DueDateDirty'
        searchField.itemName = '_dueDateCalculateState'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = [
          { code: 0, chineseName: this.$t('Billing.NotCalculated'), englishName: this.$t('Billing.NotCalculated') },
          { code: 1, chineseName: this.$t('Billing.InCalculation'), englishName: this.$t('Billing.InCalculation') },
          { code: 2, chineseName: this.$t('Billing.Calculated'), englishName: this.$t('Billing.Calculated') }
        ]
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    },
    // 费用状态：参照QueryCharge.chargeStateConditionCharge
    chargeStateConditionCharge() {
      console.log('chargeStateConditionCharge: ', this.isAr)
      const defaultSearchFields = []
      const chargeStates = []
      if (this.isAr === -1) {
        // 两个配置参数都开启,费用状态显示栏位取两者并集
        if (StrUtils.isEmpty(this.searchConditions.invoiceReceiveChargeState) && StrUtils.isEmpty(this.searchConditions.invoicePayChargeState)) {
          this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
            chargeStates.push(Number(value))
          })
          //
          this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
            if (chargeStates.indexOf(Number(value)) === -1) {
              chargeStates.push(Number(value))
            }
          })
        }
      } else if (this.isAr === 1) {
        this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
          chargeStates.push(Number(value))
        })
      } else {
        this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
          chargeStates.push(Number(value))
        })
      }
      this.searchConditions.chargeStates = chargeStates
      //
      const dataProvider = []
      if (chargeStates.length > 0) {
        dataProvider.push(CommonState.getStateByCode(ChargeConstants.CHARGE_STATES, null)) // -请选择-
        chargeStates.forEach(function(code) {
          dataProvider.push(CommonState.getStateByCode(ChargeConstants.CHARGE_STATES, code))
        })
      }
      console.log('chargeStateConditionCharge: dataProvider ', dataProvider)
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'charge.CHARGE_STATE'
      searchField.itemLabel = 'Invoice.invoice_feeStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_STATES'
      searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'ChargeConstants.CHARGE_STATES'
      searchField.dataProvider = dataProvider
      if (dataProvider.length === 0) {
        searchField.valueExpression = ''
      }
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = 2
      defaultSearchFields.push(searchField.formatObj2Json())
      //
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      this.filterChange()
      console.log('toRefreshSelectedCountChargeGrid', event)
      // this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
    },
    filterChange() {
      this.selections = getGridSelected(this.chargeGrid.gridOptions)
      this.dataShow = true
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.chargeGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
        this.totalAmountToCurrencyChargeGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
      } else if (arg == 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
        this.totalAmountToCurrencyChargeGrid.selectionCountLabel = ''
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
        this.totalAmountToCurrencyChargeGrid.selectionCountLabel = ''
      }
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      // if (value) {
      //   // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
      //   this.templateSelectorDialog.cxt = this.chargeGrid.rowData.find(item => item.uuid === value)
      //   this.templateSelectorDialog.data.JOB_UUID = value
      //   this.templateSelectorDialog.category = 'JOB_DETAIL'
      //   this.templateSelectorDialog.visible = true
      // } else {
      //   this.$message.warning(`没有找到对应的打印模板`)
      // }
      this.$emit('toSearchTemplate', value)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-charge')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationCharge.realtotal = realtotal
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
